<template>
  <div>
    <div v-if="fullOverlap.length">
      <div class="f f-gap-8">
        <div v-for="(username, i) in usernames" :key="`u-${i}`">
          <InputsToggle
            :model-value="usernameToggleValues[username]"
            @update:modelValue="(val) => usernameToggleValues[username] = val"
            :label="username"
          />
        </div>
      </div>
      <div class="f-w w-80p m-tx4">
        <WatchlistsPoster
          v-for="film in filteredList"
          :key="film.id"
          :letterboxd-film="film"
          :tmdb-film="tmdbFilmsByLetterboxdId[film.id]"
        />
      </div>
    </div>
    <div v-else class="f-ac t-20 onyx">
      <span class="material-symbols-outlined m-rx1">warning</span>
      <span>Oh no... There's no overlap! Try again.</span>
    </div>
  </div>
</template>

<script setup>
  import { ref, computed, onMounted } from 'vue';
  import axios from 'axios';
  const props = defineProps({
    films: { type: Array, required: true },
    usernames: { type: Array, required: true },
  });

  const fullOverlap = computed(() => {
    return props.films.filter((film) => film.users.length > 1);
  });

  // User Toggling
  const usernameToggleValues = ref(
    props.usernames.reduce((accumulator, currentValue) => {
      accumulator[currentValue] = true;
      return accumulator;
    }, {})
  );

  // Filtering
  const filteredList = computed(() => {
    const selectedUsernames = props.usernames.filter(u => usernameToggleValues.value[u]).sort().join(',');
    return fullOverlap.value.map((film) => {
      const users = film.users.sort().join(',');
      const disabled = selectedUsernames !== users;
      return { ...film, disabled }
    });
  });

  // Poster Loading
  const tmdbFilmsByLetterboxdId = ref({});
  const loadFilmAtIdx = (idx) => {
    // This is a recursive function that loads a film at an index, waits a bit,
    // then loads the next until they've all been loaded. TMDB theoretically
    // has a "50 API calls per second" rate limit, so I'm being safe at 40/sec
    // which ends up being every 25ms. Call it every 40ms just to be safe :).
    loadTMDBFilm(fullOverlap.value[idx]);
    idx += 1;
    if (fullOverlap.value[idx]) {
      setTimeout(() => {
        loadFilmAtIdx(idx);
      }, 40);
    }
  };
  const loadTMDBFilm = (film) => {
    const url = `/external_api/tmdb/search?title=${film.name}&year=${film.year}`;
    axios.get(url)
      .then(({ data }) => {
        const tmdbFilm = data.results[0]; // Hope to god it's the first result. It probably is.
        tmdbFilmsByLetterboxdId.value[film.id] = tmdbFilm;
      });
  };

  // Lifecycle Hooks
  onMounted(() => {
    loadFilmAtIdx(0);
  });
</script>